
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

import './index.css';
class Footer extends Component {


    render() {
        return (
            <footer id="footer" class="footer-section">
                <div class="container">
                    <div class="footer-content pt-5 pb-5">
                        <div class="row">
                            <div class="col-xl-4 col-lg-4 mb-50">
                                <div class="footer-widget">
                                    <div class="footer-logo">
                                        <a href="index-2.html" class="logo d-flex align-items-center">
                                            <img src={require('../../static/images/logo.png')} alt='' />
                                        </a>
                                    </div>
                                    <div class="footer-text">
                                        <p>We provide innovative solutions tailored to your needs. Join us in transforming your digital landscape.</p>
                                    </div>
                                    {/* <div class="footer-social-icon">
                                        <span>Follow Us</span>
                                        <a href="#" class="social-icon twitter"><i class="fa fa-twitter"></i></a>
                                        <a href="#" class="social-icon facebook"><i class="fa fa-facebook"></i></a>
                                        <a href="#" class="social-icon instagram"><i class="fa fa-instagram"></i></a>
                                        <a href="#" class="social-icon linkedin"><i class="fa fa-linkedin"></i></a>
                                    </div> */}
                                </div>
                            </div>


                            <div class="col-lg-2 col-md-6 footer-column">
                                <div class="service-widget footer-widget">
                                    <div class="footer-widget-heading">
                                        <h3>Our Services</h3>
                                    </div>
                                    <ul class="list">
                                        <li><a href="#">AI-Powered Business Automation</a></li>
                                        <li><a href="#">AI Agent Solutions</a></li>
                                        <li><a href="#">Web & App Development</a></li>
                                        <li><a href="#">AI sales Agent</a></li>
                                    </ul>
                                </div>
                            </div>


                            <div class="col-lg-2 col-md-6 footer-column">
                                <div class="service-widget footer-widget">
                                    <div class="footer-widget-heading">
                                        <h3>Information</h3>
                                    </div>
                                    <ul class="list">
                                        <li><a href="#">About Us</a></li>
                                        <li><a href="#">Portfolio</a></li>
                                        <li><a href="#">Contact</a></li>
                                        <li><a href="#">Privacy Policy</a></li>
                                    </ul>
                                </div>
                            </div>


                            <div class="col-xl-4 col-lg-4 col-md-6 mb-50">
                                <div class="contact-widget footer-widget">
                                    <div class="footer-widget-heading">
                                        <h3>Get In Touch</h3>
                                    </div>
                                    <div class="footer-text">
                                        <p><i class="fa fa-phone"></i> +1 (213) 874-8309</p>
                                        <p><i class="fa fa-envelope"></i> hello@blockhashpro.com</p>
                                        <p><i class="fa fa-map-pin"></i> Milpitas, California 95035, US</p>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="row">
                            <div class="col-12">
                                <div class="copyright-text text-center">
                                    <p>&copy; 2026 Block Hash Pro, Designed with passion.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}

export default Footer;